import React, { useRef } from "react";
import type { Destination } from "@whatslly/types/messages-server/destinations";
import { DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import { FormElement } from "@whatslly/ui-components/v2/FormElements/Form";
import { FormikProps } from "formik";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { useTranslation } from "react-i18next";
import type { DestinationFormProps, FormDestinationDataType } from "../utils/DestinationsListTypes";
const BASE_DATA: Destination = {
  type: "internalS3" as const,
  integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  settings: {} as Record<string, string>,
};

type FormDataType = FormDestinationDataType<"internalS3">;

export const InternalS3ModalForm: React.FC<DestinationFormProps<"internalS3">> = ({ onSubmitForm, settings }) => {
  const { t } = useTranslation();
  const formikContext = useRef<FormikProps<FormDataType>>(null);

  return (
    <FormElement initialValues={settings || {}} onSubmit={(data) => onSubmitForm({ ...BASE_DATA, settings: { ...data } })} formikRef={formikContext}>
      <div>Save to enable internal Custom S3 integration</div>
      <ModalButtons
        submitText={t("destinations_page.save")}
        testId={"destination-ok-button"}
        onSubmit={() => formikContext.current?.submitForm()}
        hideCancel={true}
      />
    </FormElement>
  );
};
